import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  competitorChannels: [],
  channelComparison: null,
  comparisonLoading: false,
  comparisonError: null,
};

const competitorChannelsSlice = createSlice({
  name: 'competitorChannels',
  initialState,
  reducers: {
    fetchCompetitorChannelsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCompetitorChannelsSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.competitorChannels = action.payload || [];
    },
    fetchCompetitorChannelsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearCompetitorChannels: (state) => {
      state.loading = false;
      state.error = null;
      state.competitorChannels = [];
    },
    fetchChannelComparisonStart: (state) => {
      state.comparisonLoading = true;
      state.comparisonError = null;
    },
    fetchChannelComparisonSuccess: (state, action) => {
      state.comparisonLoading = false;
      state.comparisonError = null;
      state.channelComparison = action.payload;
    },
    fetchChannelComparisonFailure: (state, action) => {
      state.comparisonLoading = false;
      state.comparisonError = action.payload;
    },
    clearChannelComparison: (state) => {
      state.channelComparison = null;
      state.comparisonLoading = false;
      state.comparisonError = null;
    },
  },
});

export const {
  fetchCompetitorChannelsStart,
  fetchCompetitorChannelsSuccess,
  fetchCompetitorChannelsFailure,
  clearCompetitorChannels,
  fetchChannelComparisonStart,
  fetchChannelComparisonSuccess,
  fetchChannelComparisonFailure,
  clearChannelComparison,
} = competitorChannelsSlice.actions;

export default competitorChannelsSlice.reducer;

